module.exports = __webpack_public_path__ + "img/NextDoorMutualLogo-01.a59643cd.png";